/**
 * JoinSLJoinPageView
 *
 * Page component for JoinSLJoinPageView
 * Path: /sl/join
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { JoinSLJoinPageView as __JoinSLJoinPageView } from '@/components/traits/JoinSLJoinPageView';
import { JoinSLJoinAnalyticsView as __JoinSLJoinAnalyticsView } from '@/components/traits/JoinSLJoinAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { SharedEntityStoreContext, useSharedEntityStore, usePageHead } from '@almadar/ui/hooks';
import { ToastSlot } from '@almadar/ui/components';

interface JoinSLJoinPageViewProps {
  // Add any page-level props here
}

export function JoinSLJoinPageView(_props: JoinSLJoinPageViewProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":["i18n/t","std-almadar-join:meta.title"],"description":["i18n/t","std-almadar-join:meta.description"],"access":"public","indexing":"noindex","origin":"https://almadar.io","siteName":"Almadar", path: __location.pathname });

  const _sharedStore = useSharedEntityStore();

  return (
    <SharedEntityStoreContext.Provider value={_sharedStore}>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__JoinSLJoinPageView config={{ initPayload: __navState }} />
          <__JoinSLJoinAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </SharedEntityStoreContext.Provider>
  );
}

export default JoinSLJoinPageView;
